import type { WithContext, WebSite, Product } from "schema-dts";

export const createStructuredData = (
  data: Partial<WebSite | Product>
): WithContext<WebSite | Product> => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Plush",
    url: "https://www.plush.com",
    description:
      "Find Your Perfect Dress with Plush – No More Endless Scrolling! Plush speaks your language and lets you shop all the top fashion brands in one place.",
    ...data,
  };
};
